import React from 'react'
import * as S from './styles'
import { StrapiFile } from '@shared/utils/strapi/strapi.types'
import { ImageDataLike } from 'gatsby-plugin-image'
import { Typography } from '@taglivros/tag-components'


const TagsCloud: React.FC<TagsCloud.Props> = ( { tagDataList } ) => {
  return (
    <S.TagsContainer>
      {tagDataList.map( ( tagData, index ) => (
        <S.Tag
          key={ `info-tag-${index}` }
          hasIcon={ Boolean( tagData.icon ) }
        >
          { tagData.icon ? (
            <S.Icon
              image={ tagData.icon }
              alt=""
            />
          ) : null}
          <Typography
            as="span"
            variant="custom-text"
            fontFamily="notoSans"
            fontWeight="s"
            fontSizeDesktop="xxs"
            fontSizeMobile="s"
            color="GREY-700-TXT"
          >
            { tagData.text }
          </Typography>
        </S.Tag>
      ) )}
    </S.TagsContainer>
  )
}

namespace TagsCloud {
  export interface Props {
    tagDataList: Array<{
      icon: StrapiFile & { localFile?: ImageDataLike };
      text: string
    }>
  }
}

export default TagsCloud
